import {simpleRequest, requestWithToken} from "../apiConfigs/request";

export const fetchCandidateAvailability = (candidateUuid) => {
  return simpleRequest({
    url: `/public/calendar/${candidateUuid}`,
    method: 'GET'
  });
}

export const saveCandidateAvailability = (candidateUuid, data) => {
  return simpleRequest({
    url: `/public/calendar/${candidateUuid}`,
    method: 'PATCH',
    data,
  });
}

export const fetchCandidateDetails = (candidateId) => {
  return requestWithToken({
    url: `/candidates/${candidateId}`,
    method: 'GET'
  });
}

export const fetchPublicCandidateProfile = (candidateUuid, isInternal = false) => {
  return simpleRequest({
    url: `/public/candidates/${encodeURIComponent(candidateUuid)}${isInternal ? '?internal=true' : ''}`,
    method: 'GET'
  });
}

export const updateCandidate = (candidateId, data) => {
  return requestWithToken({
    url: `/candidates/${candidateId}`,
    method: 'PATCH',
    data,
  });
}

export const fetchAIGeneratedSummary = (candidateId) => {
  return requestWithToken({
    url: `/llm`,
    method: 'POST',
    data: {
      type: 'candidate_summary',
      payload: {
        profileId: candidateId,
      },
      modelType: localStorage.getItem('aiModel') ? localStorage.getItem('aiModel') : 'GPT'
    },
  });
};

export const fetchSkills = () => {
  return simpleRequest({
    url: `/skills`,
    method: 'GET'
  });
}

export const fetchCandidateRole = () => {
  return simpleRequest({
    url: `/candidates/roles`,
    method: 'GET'
  });
}

export const registerCandidateProfile = (data) => {
  return simpleRequest({
    url: `/public/candidates/candidate-registration`,
    method: 'POST',
    data,
  });
}